/* eslint-disable */
import React, { useEffect } from 'react';
import { Box, List, ListItem, Card, CardContent, Typography, Checkbox,  Button, Avatar, Collapse } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataListRow from './dataListRow';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { createTheme } from '@mui/material/styles';
import EnhancedTableToolbar from '../../sharedcomponents/tableToolbar/tableToolbar';
import Paging from '../../sharedcomponents/pagination/pagination';
import DraggableList from './draggableList';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { useEventState } from '../../stores/eventStore';
import { useState } from '@hookstate/core';
import Title from '../../sharedcomponents/title/title';
import Helper from '../../utility/helper';
import NotificationToolbar from '../notificationToolBar/notificationToolBar';
import WindowDataList from '../windowDataList/windowDataList';
import UserList from '../../modules/Schedule/dataList/userList';
import { Virtuoso } from 'react-virtuoso';
import CircleIcon from '@mui/icons-material/Circle';
import VirtusoDataListRowItem from '../windowDataList/rows/moduleRows/virtusoDataListRowItem';
import VirtusoAccordianCard from '../windowDataList/rows/moduleRows/virtusoAccordianCard';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // padding: theme.spacing(2), 
    },
    listContent: {
        paddingBottom: theme.spacing(0),
        zIndex: 0,
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    virtusoPaperContent: {
        boxShadow:
            'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
        borderRadius: '4px',
        // padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    columnContent: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        top: '7px',
    },
    icon: {
        fontSize: '1.5em',
    },
    count: {
        position: 'absolute',
        // lineHeight: 0.5,
        color: '#fff',
        fontWeight: 500,
        // top: '0.5em',
        fontSize: '0.65em',
    }, 
    wrapTextStyle: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '40ch',
    },
    wrapTextSmallSize: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '30ch',
        fontSize: 12,
    },
    wrapAll: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '20ch',
    },
    transportLogo: {
        height: 15,
        width: 20,
    },
    mailLogo: {
        height: 15,
        width: 20,
        marginRight: 5,
    },

    actionIcon: {
        width: 20,
    },
    setScale: {
        transform: 'scale(1)',
        fontSize: '01rem',
        stroke: '#fff',
        strokeWidth: 1,
        marginTop: '-1px',
        marginLeft: 0,
        color: 'primary',
    },
    checkbox_style: {
        marginLeft: '-10px',
    },
}));

const DataList = (props) => {
    const classes = useStyles();
    const [listData, setListData] = React.useState([]);
    const [allListData, setAllListData] = React.useState([]);
    const [filterListData, setFilterListData] = React.useState(null);
    const [filterRoleNames, setFilterRoleNames] = React.useState([]);
    const [filterTagNames, setFilterTagNames] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [showToolbar, setShowToolbar] = React.useState(true);
    const eventState = useEventState();
    const moduleIndex = useState(-1);
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const [hotelRoomTaxID, setHotelRoomTaxID] = React.useState({
        index: '',
        value: 0,
    });
    const [expanded, setExpanded] = React.useState([]);
    const info = Helper.getStorage('eventInfo');
    const [checkAllSelect, setCheckAllSelect] = React.useState(false);

    useEffect(() => {

        if (props.allData) {
            setAllListData(props.allData)
        }
        if (!props.showSearchRec) {
            setFilterListData(props.data);
            setExpanded(props.data)
        }
        // code to hide top toolbar
        if (props.showTopbar != undefined && !props.showTopbar) {
            setShowToolbar(props.showTopbar);
        }

        if (
            eventState &&
            eventState.eventDetail.get() != null &&
            props.moduleToShow != undefined
        ) {
            getModuleDetailsData();
        }
    }, [props]);



    useEffect(() => {
        setListData(props.data);
        rolesAndTagsCount(props.data)
    }, [props.data])

    const getModuleDetailsData = () => {
        // added for showing hotel module information in all star hotel module might need to change it for draft hotel
        const moduleToShow = props.moduleToShow === "Player Hotel" ? "AllStarHotel" : props.moduleToShow;
        if (eventState.eventDetail.get() && eventState.eventDetail.get().moduleDetails) {
            const index = eventState.eventDetail
                .get()
                .moduleDetails.findIndex((element) => {
                    // console.log(props.moduleToShow)
                    if (
                        element.moduleName ===
                        (props.titleHeader ? props.titleHeader : moduleToShow)
                    ) {
                        return true;
                    }
                });
            if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo))) {
                moduleIndex.set(index);
            }
        }
    };

    // this need to be modified
    const handleFilterChangeValue = (filterObj) => {
        let modifyList = listData.filter((item) => {
            const data = item.actualData;
            if (filterObj) {
                return Object.keys(filterObj).every((filter) => {
                    let val =
                        typeof filterObj[filter] === 'string' &&
                            filter === 'transportType'
                            ? filterObj[filter].toLowerCase()
                            : filterObj[filter];

                    //added below code for request status
                    if (filter === 'requestStatus') {
                        if (val === 'Not Approved') {
                            val = 'Rejected'
                        }
                        return data[filter] === val;
                    }
                    else
                        return val.includes(data[filter]);

                });
            }
        });

        if (filterObj) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }
            setFilterListData(modifyList);
            props.filterListData(modifyList);
        } else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    };

    const handleOnChange = (event) => {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }
            let modifyList = [];
            let finalData = allListData.length > 0 ? allListData : listData;
            // console.log("finalData123",finalData);
            finalData.map((val) => {
                return (val.actualData.userType && val.actualData.userType !== "Admin" ? val.actualData.userType = "" : val.actualData.userType);
            })
            finalData.forEach((item) => {
                let data = item.actualData;
                let keys = Object.keys(data);
                keys.forEach((key) => {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) >
                        -1
                    ) {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
            rolesAndTagsCount(modifyList)
            setFilterListData(modifyList);
            if (props.filterListData) props.filterListData(modifyList);
        } else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }
            rolesAndTagsCount(listData)
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    };
    const rolesAndTagsCount = (data) => {
        let roleName = [];
        let tagName = []
        data && data.length > 0 && data.map((value) => {
            if (value.actualData.userTags !== "" || value.actualData.userTags !== null) {
                let splitTags = value.actualData.userTags?.split(',')
                if (splitTags && splitTags.length > 0) {
                    splitTags.map((value) => {
                        tagName.push({
                            tags: value.trim()
                        })
                    })

                }
            }
            if (value.actualData.roleName !== '') {
                roleName.push({
                    name: value.actualData.name,
                    roleName: value.actualData.roleName,
                })
            }
        })
        var reduceRoleName = roleName && roleName.length > 0 && roleName.reduce((a, b) => {
            var i = a.findIndex(x => x.roleName === b.roleName);
            return i === -1 ? a.push({ roleName: b.roleName, times: 1 }) : a[i].times++, a;
        }, []);
        var reduceTags = tagName && tagName.length > 0 && tagName.reduce((a, b) => {
            var i = a.findIndex(x => x.tags === b.tags);
            return i === -1 ? a.push({ tags: b.tags.trim(), times: 1 }) : a[i].times++, a;
        }, []);

        setFilterRoleNames(reduceRoleName)
        setFilterTagNames(reduceTags)
        //  console.log("data",data,"tagName",tagName, roleName,reduceRoleName, reduceTags);
    }
    const onCheckSelect = (event, index) => {
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.checked;
        setFilterListData(newFilterList);
    };
    const onCheckVirtusoSelectAll = (e) => {
        let newFilterList = [...filterListData];
        newFilterList.forEach((item) => {
            item.selected = e.target.checked;
        });
        setCheckAllSelect(e.target.checked);
        setFilterListData(newFilterList);
        if (props.filterListData)
            props.filterListData(newFilterList);
    }
    const onCheckSelectAll = (event) => {
        let newFilterList = [...filterListData];
        newFilterList.forEach((item, index) => {
            if (props.showSendInvite && props.showSendInvite !== undefined) {
                if (item.actualData.email !== null) {
                    const nbaDomain = item.actualData.email.split('@');
                    // console.log("nbaDomain", nbaDomain[1]);
                    if (
                        item.actualData.registerDate === null &&
                        nbaDomain &&
                        nbaDomain[1] !== 'nba.com'
                    ) {
                        newFilterList[index]['selected'] = event.target.checked;
                    }
                }
            } else {
                newFilterList[index]['selected'] = event.target.checked;
            }
        });
        setFilterListData(newFilterList);
    };

    const onChangeHotelRoom = (event, index) => {
        setHotelRoomTaxID({
            ...hotelRoomTaxID,
            index: index,
            value: event.target.value,
        });
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.value;
        setFilterListData(newFilterList);
    };

    const handleEditAll = () => {
        props.editAllToggle();
    };
    const handleHotelSave = () => {
        let newFilterList = [...filterListData];
        props.editAll(newFilterList);
    };
    const onParticipantTagClick = (data) => {
        let str = data.roleName ? data.roleName : data.tags;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }
            let modifyList = [];
            let finalData = allListData.length > 0 ? allListData : listData;
            finalData.map((val) => {
                return (val.actualData.userType && val.actualData.userType !== "Admin" ? val.actualData.userType = "" : val.actualData.userType);
            })
            finalData.forEach((item) => {
                let data = item.actualData;
                let keys = Object.keys(data);
                keys.forEach((key) => {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) >
                        -1
                    ) {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
            setFilterListData(modifyList);
            rolesAndTagsCount(modifyList);

            if (props.filterListData) props.filterListData(modifyList);
        } else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }
            rolesAndTagsCount(listData)
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    }
    const handleClearSearchChange = () => {
        setSearch("")
        if (props.setShowSearchRec != undefined) {
            props.setShowSearchRec(false);
        }
        rolesAndTagsCount(listData)
        setFilterListData(listData);
        if (props.filterListData) props.filterListData(listData);
    }

    const gettagTotalCount = () => {
        const totalCount = filterTagNames.reduce((acc, data) => {
            if (data.tags !== null) {
                acc += data.times;
            }
            return acc;
        }, 0);

        return totalCount;
    };
    const getrolesTotalCount = () => {
        const totalCount = filterRoleNames.reduce((acc, data) => {
            if (data.tags !== null) {
                acc += data.times;
            }
            return acc;
        }, 0);

        return totalCount;
    };
    const renderYesNoCount = () => {
        let yescount = 0;
        let nocount = 0;
        let count = 0;

        const distinctUser = props.allData?.filter((item, index, self) => {
            return index === self.findIndex((t) => (
                t.actualData.addedFor === item.actualData.addedFor
            ));
        });

        if (distinctUser) {
            if (
                distinctUser.length > 0 &&
                distinctUser[0].actualData.hotelAgentRoomRequest.length > 0
            ) {
                yescount =
                    distinctUser[0].actualData.hotelAgentRoomRequest[0]
                        .acceptedCount;
                nocount =
                    distinctUser[0].actualData.hotelAgentRoomRequest[0]
                        .rejectedCount;
                count =
                    distinctUser[0].actualData.hotelAgentRoomRequest[0]
                        .notApplicableCount;
            }
        }



        // if (distinctUser) {
        //     distinctUser.length > 0 &&
        //         distinctUser.forEach((item) => {
        //             if (item.actualData.hotelAgentRoomRequest.length > 0) {
        //                 item.actualData.hotelAgentRoomRequest.forEach(
        //                     (elem) => {
        //                         if (elem.isAgentRoomRequestAccepted == true) {
        //                             yescount++;
        //                         } else if (
        //                             elem.isAgentRoomRequestAccepted == false
        //                         ) {
        //                             nocount++;
        //                         }
        //                     }
        //                 );
        //             } else {
        //                 count++;
        //             }
        //         });
        // }
        return (
            <Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                    }}>
                    <Box>
                        <Typography
                            variant="subtitle2"
                            color={'primary'}
                            component={'span'}>
                            Do you want to reserve one (1) hotel room for
                            your certified agent (at the agent’s expense)?
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '350px',
                            alignItems: 'center',
                            justifyContent: 'center',
                            ml: '20px',
                            pb: '2px',
                        }}>
                        <Box
                            sx={{
                                width: '100%',
                                //flexBasis: '180px',
                                flexGrow: 1,
                                margin: '10px 0px 5px 10px',
                                flexWrap: 'wrap',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'left',
                                    alignItems: 'center',
                                    width: '100%',
                                    gap: '10px',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={500}
                                    color="primary">
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        Yes :
                                    </span>
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#DFE3EC',
                                        borderRadius: '14px',
                                        width: '50px',
                                        //padding:'2px'
                                    }}>
                                    {yescount}
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                //flexBasis: '180px',
                                flexGrow: 1,
                                margin: '5px 0px 0px 10px',
                                flexWrap: 'wrap',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'left',
                                    alignItems: 'center',
                                    width: '100%',
                                    gap: '10px',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={500}
                                    color="primary">
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        No :{' '}
                                    </span>
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#DFE3EC',
                                        borderRadius: '14px',
                                        width: '50px',
                                        //padding:'2px'
                                    }}>
                                    {nocount}
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                //flexBasis: '180px',
                                flexGrow: 1,
                                margin: '5px 0px 0px 10px',
                                flexWrap: 'wrap',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'left',
                                    alignItems: 'center',
                                    width: '100%',
                                    gap: '10px',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={500}
                                    color="primary">
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                        N/A :{' '}
                                    </span>
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#DFE3EC',
                                        borderRadius: '14px',
                                        width: '50px',
                                        //padding:'2px'
                                    }}>
                                    {count}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }; 
    const handleExpand = (item, modules) => {
        let indexs = 0;
        let newFilterList = [...listData];
        switch (modules) {  
            case 'Hotel':
            case 'Player Hotel':
            case 'PlayerHotel':
                indexs = newFilterList.findIndex(
                    (x) => x.actualData.hotelBookID === item.actualData.hotelBookID
                );
                break;
            case 'Transportation':
            case 'Flight Info':
                indexs = newFilterList.findIndex(
                    (x) => x.actualData.transportID === item.actualData.transportID
                );
                break;  
            case 'Registration':
            case 'DraftRegistration':
            case 'All Star Registration': 
                indexs = newFilterList.findIndex(
                    (x) => x.actualData.registrationID === item.actualData.registrationID
                );
                break; 
            case 'Combine Flight Info': 
            case 'DraftFlightInfo':
            case 'Draft Flight Info':                
                indexs = newFilterList.findIndex(
                    (x) => x.actualData.flightInfoID === item.actualData.flightInfoID
                );
                break;
            case 'Credential':
                indexs = newFilterList.findIndex(
                    (x) => x.actualData.credentialID === item.actualData.credentialID
                );
                break; 
            case 'Draft Transportation':
                indexs = newFilterList.findIndex(
                    (x) => x.actualData.draftTransportID === item.actualData.draftTransportID
                );
                break;  
            default:
                indexs = 0  
        }            
        if (indexs > -1) {
            newFilterList[indexs]['expanded'] = !item.expanded;
            setListData(newFilterList);
        }
    }  
    const rowItemContent = (index, item) => {               
        return (
            <ListItem sx={{ padding: 1, pb:2 }}>
                <Card
                    classes={{ root: classes.virtusoPaperContent }}
                    sx={{ width: '100%' }}
                >
                    <CardContent
                        className={classes.cardContent}>
                        <div key={`virtuso_list_${index}`} className={classes.addTopPad}>
                            <div style={{ display: 'flex', padding: 8 }}>
                                {item && item.row && item.row.map((row, rowIndex) => (
                                    <>
                                        <VirtusoDataListRowItem
                                            key={`datarowitem_${rowIndex}`}
                                            row={row}
                                            item={item}
                                            index={index}
                                            {...props}
                                            onCheckSelect={onCheckSelect}
                                            classes={classes}
                                        />
                                    </>
                                ))}
                                <Box className={classes.columnContent}>
                                    <span style={{cursor:'pointer'}} onClick={() => handleExpand(item, props.moduleToShow)} >
                                        {item.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </span>
                                </Box>
                            </div>

                            <Collapse in={item.expanded} timeout="auto" unmountOnExit>
                                <List sx={{padding:1}}>
                                    <VirtusoAccordianCard
                                        moduleToShow={props.moduleToShow}
                                        classes={classes}
                                        item={item}
                                        {...props}
                                    />
                                </List>
                            </Collapse>
                        </div>
                    </CardContent>
                </Card>
            </ListItem>
        )
    }
    const statusValues = (value, status) => {
        return (
            <Box
                className={classes.wrapper}
                style={{
                    fontSize: 14,
                }}>
                <CircleIcon
                    style={{
                        color:
                            status === 'Pending'
                                ? '#C59B64'
                                : status === 'Approved'
                                    ? '#169D3C'
                                    : 'red',
                    }}
                    className={classes.icon}
                />
                <Typography component="span" className={classes.count}>
                    {value}
                </Typography>
            </Box>
        );
    };
    return (
        <Box className={classes.boxContent}>
            {props.moduleToShow ? 
                <Box
                    display="flex"
                    flexDirection={'row'}
                    justifyContent={'space-between'}
                    margin={'16px 0px 0px 16px'}>
                    <Title title={props.moduleDisplayName ? props.moduleDisplayName : props.moduleToShow} />
                </Box> : null}
               
            {props.showAlphabetFilter ? (
                <Box sx={{ pr: 1.5, display:'flex', gap:1 }}>
                    {props.alphabet && props.alphabet.map((val, i) => {
                        return(
                            <Avatar   sx={{ width: 24, height: 24, background:props.currentAlpha === val ? '#1764BC' : 'none', cursor:'pointer',color:props.currentAlpha === val ? 'white' : '#1764BC', }} aria-label={val}  onClick={() => props.clickAlphabet(val,i)} >{val}</Avatar>) 
                    })}
                    <Button
                        variant="contained"
                        style={{ fontSize: 13 }}
                        onClick={() => props.handleReset()}>
                        Reset{' '}
                    </Button>
                </Box>
            )                               
            : null}
            {props.moduleToShow != undefined &&
                eventState.eventDetail.get() &&
                ((moduleIndex.get() >= 0 &&
                    eventState.eventDetail.get().moduleDetails[
                        moduleIndex.get()
                    ].details != null) ||
                    '') && (
                    <DetailsComponent
                        data={
                            eventState.eventDetail.get().moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                )}
            <Box component="div" sx={{ display: 'flex' }}>

                {props.showUsersList && (
                    <Box
                        component="div"
                        sx={{
                            width: '20%',
                            padding: '0 8px',
                            display: 'flex',
                        }}>
                        <UserList
                            participants={props.contactParticipants}
                            handleUserClick={props.contactHandleUserClick}
                            handleAddToPdfListArray={props.handleAddToPdfListArray}
                            allSelect={props.selectAllFlag ? true : false}
                            selected={props.selectedUser}
                            showCheckBoxes={props.showCheckBoxes}
                        />
                    </Box>
                )}
                <Box
                    component="div"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: props.showUsersList ? '80%' : '100%',
                    }}>
                    {showToolbar ? (
                        <EnhancedTableToolbar
                            {...props}
                            search={search}
                            hideEdit={props.hideEdit ? true : false}
                            showSendAll={props.showSendAll ? true : false}
                            sendAllbuttonTitle={props.showSendAll ? 'Send All' : null}
                            showEdit={props.showEdit ? true : false}
                            showEdittags={props.showEdittags ? true : false}
                            showEditroles={props.showEditroles ? true : false}
                            editButtonTitle={props.showEdit ? true : false}
                            handleSearchChange={handleOnChange}
                            handleFilterChange={handleFilterChangeValue}
                            handleSendEmail={props.handleSendEmail}
                            hideAdd={props.hideAdd ? true : false}
                            modPermission={props.modPermission}
                            disableAdd={props.disableAdd}
                            onCheckSelectAll={onCheckSelectAll}
                            showEditHotel={props.showEditHotel ? true : false}
                            handleEditAll={handleEditAll}
                            showHotelToggle={props.showHotelToggle}
                            saveHotelButtonTitle={props.saveHotelButtonTitle}
                            handleHotelSave={handleHotelSave}
                            eventConfigStatus={props.eventConfigStatus}
                            compUsed={props.compUsed}
                            purchaseUsed={props.purchaseUsed}
                            showAgentRoomInfo={props.showAgentRoomInfo}
                            isAgentRequestAccepted={props.isAgentRequestAccepted}
                            handleAgentRoomConfirmation={props.handleAgentRoomConfirmation}
                            readOnlyOrHide={info && info.readonlyOrHide}
                            filterRoleNames={filterRoleNames}
                            filterTagNames={filterTagNames}
                            moduleIndex={moduleIndex.get()}
                            onParticipantTagClick={onParticipantTagClick}
                            handleClearSearchChange={handleClearSearchChange}
                            gettagTotalCount={gettagTotalCount}
                            getrolesTotalCount={getrolesTotalCount}
                            hideTagFilter={props.hideTagFilter}
                        />
                    ) : !props.hideToolBar && (
                        <NotificationToolbar
                            {...props}
                            search={search}
                            handleSearchChange={handleOnChange}
                            onCheckSelectAll={onCheckSelectAll}
                            showSearch={props.showSearch}
                        />
                    )}
                    <Box
                        component="div"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '350px',
                            mb: 1,
                        }}>
                        {props.showRequestStatus ? (
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={600}>
                                Pending :{' '}
                                {statusValues(
                                    props.showRequestStatus.Pending,
                                    'Pending'
                                )}
                            </Typography>
                        ) : null}
                        {props.showRequestStatus ? (
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={600}>
                                Approved :{' '}
                                {statusValues(
                                    props.showRequestStatus.Approved,
                                    'Approved'
                                )}
                            </Typography>
                        ) : null}
                        {props.showRequestStatus ? (
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={600}>
                                Not Approved :{' '}
                                {statusValues(
                                    props.showRequestStatus.Rejected,
                                    'Rejected'
                                )}
                            </Typography>
                        ) : null}
                    </Box>
                    {props.showUserName && (<Box component={'div'} sx={{mt:1}}>
                        <Typography variant="subtitle2">{props.selectedUserName}</Typography>
                    </Box>)}
                    {props.showYesNoCount ?
                        renderYesNoCount()
                    : null}
                    {props.isDraggable != undefined ? (
                        <DraggableList
                            classes={classes}
                            data={filterListData}
                            onDragEnd={props.onDragEnd}
                            editRow={props.editRow}
                            modPermission={props.modPermission}
                            {...props}
                            showModuleSetting={props.showModuleSetting}
                            onModuleSettingClick={props.onModuleSettingClick}
                            onCheckContactSelect={props.onCheckContactSelect}
                        />
                    ) : (
                        // <List className={classes.listContent}>
                        //     {filterListData && filterListData.length > 0 ? (
                        //         filterListData.map((item, index) => (
                        //             <DataListRow
                        //                 key={`datarow_${index}`}
                        //                 item={item}
                        //                 index={index}
                        //                 onCheckSelect={onCheckSelect}
                        //                 editRow={props.editRow}
                        //                 viewPage={props.viewPage}
                        //                 onSwitchToggle={props.onSwitchToggle}
                        //                 onActionClick={props.onActionClick}
                        //             />
                        //         ))
                        //     ) : (
                        //         <ListItem className={classes.listItemContent}>
                        //             <Card
                        //                 classes={{ root: classes.paperContent }}
                        //                 sx={{ width: '100%' }}>
                        //                 <CardContent
                        //                     sx={{ p: 2 }}
                        //                     className={classes.cardContent}>
                        //                     <Box className={classes.rowContent}>
                        //                         No data found
                        //                     </Box>
                        //                 </CardContent>
                        //             </Card>
                        //         </ListItem>
                        //     )}
                        // </List>
                        <>
                            {props.showContactListCheckBox ? (
                                <Box
                                    sx={{
                                        width: '100%',
                                        ml: 1,
                                        display: 'flex',
                                    }}>
                                    <Checkbox
                                        // color="secondary"
                                        checked={props.contactListChecked}
                                        className={
                                            classes.checkbox_style
                                        }
                                        onChange={(e) =>
                                            props.onCheckedContactListChange(e)
                                        } 
                                    />
                                    <Typography sx={{ mt: 1 }}>
                                        Show Email
                                    </Typography>
                                </Box>
                            ) : null}
                            {props.showVirtusoSelectAll ? (
                                <Box
                                    sx={{
                                        width: '100%',
                                        ml: 1,
                                        display: 'flex',
                                    }}>
                                    <Checkbox
                                        // color="secondary"
                                        checked={checkAllSelect}
                                        className={
                                            classes.checkbox_style
                                        }
                                        onChange={(e) =>
                                            onCheckVirtusoSelectAll(e)
                                        }
                                        value={checkAllSelect}
                                    />

                                    <Typography sx={{ mt: 1 }}>
                                        Select All
                                    </Typography>
                                </Box>
                            ) : null}
                            {props.windowDataList != undefined && props.windowDataList ?
                                props.moduleVirtusoDataList != undefined && props.moduleVirtusoDataList ? (
                                    filterListData && filterListData.length > 0 ? (
                                        <List className={classes.listContent}>
                                            <div style={{ display: 'flex', height: '70vh' }}>
                                                <div style={{ flex: '1 1 auto' }}>
                                                    <Virtuoso
                                                        style={{ height: '100%' }}
                                                        data={filterListData}
                                                        // endReached={loadMore}
                                                        increaseViewportBy={300}
                                                        itemContent={rowItemContent}
                                                    />
                                                </div>
                                            </div>
                                        </List>
                                    ) :
                                        filterListData && filterListData.length == 0 ?
                                            <List className={classes.listContent}>
                                                <ListItem className={classes.listItemContent}>
                                                    <Card
                                                        classes={{ root: classes.paperContent }}
                                                        sx={{ width: '100%' }}>
                                                        <CardContent
                                                            sx={{ p: 2 }}
                                                            className={classes.cardContent}>
                                                            <Box className={classes.rowContent}>
                                                                No data found
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                </ListItem>
                                            </List>
                                            : null
                                ) :
                                    filterListData && filterListData.length > 0 ? (
                                        <WindowDataList
                                            data={filterListData}
                                            onCheckSelect={onCheckSelect}
                                            modPermission={props.modPermission}
                                            editRow={props.editRow}
                                            addConnection={props.addConnection}
                                            addConnectionLinkedWith={
                                                props.addConnectionLinkedWith
                                            }
                                            deleteConnection={props.deleteConnection}
                                            rowType={props.rowType}
                                            editTemplate={props.editTemplate}
                                            editSendEmail={props.editSendEmail}
                                            emailLoading={props.emailLoading}
                                            editLoading={props.editLoading}  
                                        />
                                    ) :
                                        filterListData && filterListData.length == 0 ?
                                            <List className={classes.listContent}>
                                                <ListItem className={classes.listItemContent}>
                                                    <Card
                                                        classes={{ root: classes.paperContent }}
                                                        sx={{ width: '100%' }}>
                                                        <CardContent
                                                            sx={{ p: 2 }}
                                                            className={classes.cardContent}>
                                                            <Box className={classes.rowContent}>
                                                                No data found
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                </ListItem>
                                            </List>
                                            : null
                                :
                                (
                                    <List className={classes.listContent} sx={props.auditPage ? { paddingLeft: 1, paddingRight: 1 } : {}}>
                                        {filterListData && filterListData.length > 0 ? (
                                            filterListData.map((item, index) => (
                                                <DataListRow
                                                    {...props}
                                                    key={`datarow_${index}`}
                                                    item={item}
                                                    index={index}
                                                    onCheckSelect={onCheckSelect}
                                                    onCheckSelectAll={onCheckSelectAll}
                                                    editRow={props.editRow}
                                                    editTemplate={props.editTemplate}
                                                    editSendEmail={props.editSendEmail}
                                                    viewPage={props.viewPage}
                                                    onSwitchToggle={props.onSwitchToggle}
                                                    onActionClick={props.onActionClick}
                                                    onPendingAction={props.onPendingAction}
                                                    addConnection={props.addConnection}
                                                    addConnectionLinkedWith={
                                                        props.addConnectionLinkedWith
                                                    }
                                                    deleteConnection={props.deleteConnection}
                                                    modPermission={props.modPermission}
                                                    copyToClipboard={props.copyToClipboard}
                                                    outfitInfo={props.outfitInfo}
                                                    onChangeHotelRoom={onChangeHotelRoom}
                                                    hotelRoomTaxID={hotelRoomTaxID}
                                                    hotelKeyValue={props.hotelKeyValue}
                                                    readOnlyOrHide={info && info.readonlyOrHide}
                                                />
                                            ))
                                        ) : (
                                            filterListData && filterListData.length == 0 ?
                                                <ListItem className={classes.listItemContent}>
                                                    <Card
                                                        classes={{ root: classes.paperContent }}
                                                        sx={{ width: '100%' }}>
                                                        <CardContent
                                                            sx={{ p: 2 }}
                                                            className={classes.cardContent}>
                                                            <Box className={classes.rowContent}>
                                                                No data found
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                </ListItem>
                                                : null
                                        )}
                                    </List>
                                )}
                        </>
                    )}

                    {props.pagingInfo &&
                        props.pagingInfo.noOfPages > 1 &&
                        !props.showSearchRec ? (
                        <Box
                            sx={{
                                p: 2,
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            <Paging
                                pagingInfo={props.pagingInfo}
                                handlePageChange={props.handlePageChange}
                            />
                        </Box>
                    ) : null}
                </Box>
            </Box>

        </Box>
    );
};

export default DataList;
